import React, { ComponentProps } from 'react';
import { TableHead as CarbonTableHead } from '@carbon/react';

export type TableHeadProps = ComponentProps<typeof CarbonTableHead>;

export const TableHead = (props: TableHeadProps) => (
  <CarbonTableHead {...props} />
);

TableHead.displayName = 'TableHead';
